const GRADE = [{
  label: '初一',
  value: '1'
}, {
  label: '初二',
  value: '2'
}, {
  label: '初三',
  value: '3'
}, {
  label: '高一',
  value: '4'
}, {
  label: '高二',
  value: '5'
}, {
  label: '高三',
  value: '6'
}, {
  label: 'G1',
  value: '7'
}, {
  label: 'G2',
  value: '8'
}, {
  label: 'A1',
  value: '9'
}, {
  label: 'A2',
  value: '10'
}]
export {
  GRADE
}
